import { AxiosResponse } from 'axios';
import api from '~/services/api';

class FocusSupplierService {
  getFocusSupplierList({ skip = 0, limit = 30, ...rest }, opts: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/tag-focus/', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getListCount({ skip = 0, limit = 30, ...rest }, opts: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/tag-focus/', {
      params: {
        skip,
        limit,
        isCount: true,
        ...rest
      },
      ...opts
    });
  }

  getByIdFocusSupplier(id: string, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get(`/tag-focus/${id}`, {
      ...opts
    });
  }

  deleteFocusSupplier(id: string): Promise<AxiosResponse<any[] | null>> {
    return api.delete(`/tag-focus/${id}`);
  }

  saveFocusSupplier(data: any): Promise<AxiosResponse<any[] | null>> {
    return api.post('/tag-focus/', {
      ...data
    });
  }

  editFocusSupplier({ id, data }: { id: string; data: any }): Promise<AxiosResponse<any[] | null>> {
    return api.put(`/tag-focus/${id}`, {
      ...data
    });
  }
}

export default new FocusSupplierService();
